module.exports = __webpack_public_path__ + "img/mobtotsections.dd5f346b.svg";